import { render, staticRenderFns } from "./TbkReport.vue?vue&type=template&id=058a27f6&lang=pug&"
import script from "./TbkReport.vue?vue&type=script&lang=js&"
export * from "./TbkReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TbkReport.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VForm,
  VLayout,
})
